import { module } from 'modujs'
import { createApp, computed, ref } from 'vue/dist/vue.esm-bundler.js'
import { gsap } from '../lib/gsap'
import { MODAL_CONTENT_KEYS, VUE_SETTINGS } from '../config'

export default class extends module {


    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
    }

    init() {

        this.vueApp = createApp({
            ...VUE_SETTINGS,
            setup: () => {

                // DOM refs
                const hoverRef = ref()

                // Reactive Data
                const isHovering = ref(false)
                const currentAsset = ref({})
                const currentModalId = ref(null)

                // Computed
                const hasCurrentAsset = computed(() => typeof currentAsset.value.src !== 'undefined')

                // Methods
                const onMouseEnter = () => isHovering.value = true
                const onMouseLeave = () => isHovering.value = false
                const setAsset = (asset = {}) => {
                    asset = JSON.parse(asset)
                    currentAsset.value = Object.assign(asset, {})
                }
                const openModal = id => {
                    currentModalId.value = id
                    this.call('open', { type: MODAL_CONTENT_KEYS.ATHLETE, id }, 'ModalContent')
                }
                const closeModal = () => currentModalId.value = null

                return {
                    hoverRef,
                    isHovering,
                    currentAsset,
                    hasCurrentAsset,
                    currentModalId,
                    onMouseEnter,
                    onMouseLeave,
                    setAsset,
                    openModal,
                    closeModal,
                }
            }
        })
        this.vueMountedApp = this.vueApp.mount(this.$el)
    }

    onModalClose() {
        this.vueMountedApp.closeModal()
    }

    destroy() {
        this.vueApp?.unmount()
    }
}

